module.exports = __webpack_public_path__ + "static/img/14000680.06d5a74d.png";